import { ModuleWithProviders, NgModule, APP_INITIALIZER, ErrorHandler, Type } from '@angular/core';
import { LOGGER_CONFIG, LOGGER_HTTP_SENDER } from './logger.tokens';
import { DefaultLoggerHttpSender } from './logger.default-sender';
import { LoggerErrorHandler } from './logger.error-handler';
import { LoggerRouteTracker } from './logger.route-tracking';
import { LoggerService } from './logger.service';
import { LoggerConfig, LoggerHttpSender } from './logger.types';

export interface LoggerModuleOptions {
  config: LoggerConfig;
  /** Optional class that implements LoggerHttpSender. If omitted, the default HttpClient sender is used. */
  httpSender?: Type<LoggerHttpSender>;
}

@NgModule({})
export class LoggerModule {
  static forRoot(options: LoggerModuleOptions): ModuleWithProviders<LoggerModule> {
    return {
      ngModule: LoggerModule,
      providers: [
        { provide: LOGGER_CONFIG, useValue: options.config },
        { provide: LOGGER_HTTP_SENDER, useClass: options.httpSender ?? DefaultLoggerHttpSender },
        { provide: ErrorHandler, useClass: LoggerErrorHandler },
        {
          provide: APP_INITIALIZER,
          multi: true,
          deps: [LoggerService, LoggerRouteTracker],
          useFactory: (_logger: LoggerService, tracker: LoggerRouteTracker) => () => { tracker.start(); },
        },
      ],
    };
  }
}
